import { Country } from 'react-phone-number-input';

import { EligibilityStatus } from '../../metadata/enums';

export type User = {
  id: Guid;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  patientInfo?: PatientRecord;
  clinicianInfo?: ClinicianRecord;
  advocateInfo?: AdvocateRecord;
  countryCode: Country;
  isImpersonating: boolean;
};

export enum UserRole {
  Patient = 0,
  Clinician = 1,
  Support = 2,
  Administrator = 3,
  ClinicAdministrator = 4,
  Finance = 5,
  Sales = 6,
  Viewer = 7,
  Advocate = 8,
}

export enum MolecularLabTestStatus {
  AwaitingClinicianSignature = 0,
  AwaitingPatientSignature = 1,
  Submitted = 2,
  AwaitingResults = 3,
  Complete = 4,
}

export const UserRoleDescription = {
  [UserRole.Patient]: 'Patient',
  [UserRole.Clinician]: 'Clinician',
  [UserRole.Support]: 'Support',
  [UserRole.Administrator]: 'Administrator',
  [UserRole.ClinicAdministrator]: 'Clinic administrator',
  [UserRole.Finance]: 'Finance',
  [UserRole.Sales]: 'Sales',
  [UserRole.Viewer]: 'Viewer',
  [UserRole.Advocate]: 'Advocate',
};

export type PatientRecord = {
  id: Guid;
  isIndirect: boolean;
  isEnrolled: boolean;
  eligibilityStatus?: EligibilityStatus;
  hasPaid: boolean;
  molecularLabTestStatus?: MolecularLabTestStatus;
  packageSelected?: number;
  astronReportDelivered: boolean;
};

export type ClinicianRecord = {
  id: Guid;
  canAccessAstronReport: boolean;
  clinicPaysWithStripe: boolean;
  canOrderMolecularTest: boolean;
};

export type AdvocateRecord = {
  id: Guid;
  isVanillaAffiliate: boolean;
};
